
import axios from 'axios';
import qs from 'qs';
import { setStore, getStore, token_key, userInfo_key } from './localCache';
import urlObjc from '../urls/urls';
import router from '@/router/routers';
import {Loading} from 'element-ui';

//loading配置
let loadingOption = {
  lock: true,
  text: '拼命加载中...',
  // spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
}
let loadingObjc;

axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
if (process.env.NODE_ENV == 'development') {
  //http://shdevapi.myspss.com
  //http://shapi.myspss.com
  axios.defaults.baseURL = 'http://shapi.myspss.com';
} else {
  axios.defaults.baseURL = 'http://shapi.myspss.com';
}
// axios.defaults.headers.common['Authorization'] = storage.getStore(storage.token_key);
axios.defaults.headers['token'] = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzcHNzIiwiY3JlYXRlZCI6MTU2OTQ1OTM4NTM4MCwiZXhwIjoxNTcwMDY0MTg1fQ.Nu-LoRvsAhzrGJVKq2Wr-kZrN38Zc6WlPwnbr3w3VOaQhecYiwLWBxgE6ZafWAb-iUvRn45ewOW2IVMpl_4A3g';

//post传参序列化
axios.interceptors.request.use((config) => {
  if (config.method == 'post') {
    config.data = qs.stringify(config.data);
  }
  loadingObjc = Loading.service(loadingOption);
  if (getStore(userInfo_key) == undefined) {
    router.push('/login');
  }
  return config;
}, (error) => {
  loadingObjc.close();
  console.log("-------------错误的传参");
  return Promise.reject(error);
})

//返回状态的判断, -----------在这里判断token是否过期过期就跳转登录界面
axios.interceptors.response.use((res) => {
  loadingObjc.close();
  var result = res.data;
  if (result.code != 200) {
    return Promise.reject(res);
  }
  // if (getStore(token_key) == null) {
  //   setStore(token_key, res.headers.authorization);
  // }
  return result;
}, (error) => {
  loadingObjc.close();
  if (error.response.status === 401 || error.response.status === 403) {
    router.push('/login');
  }
  return Promise.reject(error);
})

//get请求
function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: param
    }).then(response => {
      resolve(response);
    }).catch(error => {
      console.log("-------------返回数据错误" + error);
      reject(error);
    })
  });
}

//post请求
function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}


export default {
  
  ///登录
  login(params) {
    return fetchPost(urlObjc.loginUrl, params);
  },
  ///首页数据
  requestHomeData(params) {
    return fetchGet(urlObjc.homeDataUrl, params);
  },
  ///设置指定网关是否可展示
  updateGatewayIsShow(params, gateway) {
    return fetchGet(urlObjc.settingGatewayIsShow + gateway, params);
  },
  ///空调电量
  requestAirElectricity(params, gateway) {
    return fetchGet(urlObjc.airElectricityUrl + gateway, params);
  },
  ///新风电量
  requestFreshAirElectricity(params, gateway) {
    return fetchGet(urlObjc.freshAirElectricityUrl + gateway, params);
  },
  ///热水电量
  requestHotWater(params, gateway) {
    return fetchGet(urlObjc.hotWaterUrl + gateway, params);
  },
  ///灯控电量
  requestLampElectricity(params, gateway) {
    return fetchGet(urlObjc.lampElectricityUrl + gateway, params);
  },
  ///插座电量
  requestSocketElectricity(params, gateway) {
    return fetchGet(urlObjc.socketElectricityUrl + gateway, params);
  },
  ///净水电量
  requestPurificationWaterElectricity(params, gateway) {
    return fetchGet(urlObjc.purificationWaterElectricityUrl + gateway, params);
  },
  ///环境历史数据
  requestEnvHistoryData(params, gateway) {
    return fetchGet(urlObjc.envHistoryDataUrl + gateway, params);
  },
  ///各系统下能耗
  requestSystemEnergys(params, gateway) {
    return fetchGet(urlObjc.systemEnergysUrl + gateway, params);
  },
  ///获取智能模块各系统下能耗对比数据
  requestSmartSystemEnergys(params, gateway) {
    return fetchGet(urlObjc.smartSystemEnergysUrl + gateway, params);
  },
  ///采暖系统智能能耗
  requestSmartHeatingEnergys(params, gateway) {
    return fetchGet(urlObjc.smartHeatingSystemUrl + gateway, params);
  },
  ///通过前多少天获取采暖系统气量数据
  requestHeatingGasWithDay(params, equipmentId) {
    return fetchGet(urlObjc.smartHeatingGasWithDayUrl + equipmentId, params);
  },
}


// WEBPACK FOOTER //
// ./src/utils/requestObjc.js